module.exports = __webpack_public_path__ + "img/man.692ccc34.png";